import { GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid'

const OffersCustomToolbar = () => {
  return (
    <GridToolbarContainer
      sx={{
        p: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        alignContent: 'center',
        position: 'relative',
        gap: 2
      }}
    >
      <GridToolbarQuickFilter
        sx={{
          verticalAlign: 'middle',
          marginBottom: 0,
          paddingBottom: 0
        }}
      />
      <GridToolbarExport
        sx={{
          '&.MuiButton-root': {
            backgroundColor: '#FC3E6F',
            color: 'white',
            minWidth: 'auto',
            padding: '6px 16px',
            '&:hover': {
              backgroundColor: '#e53958'
            }
          }
        }}
      />
    </GridToolbarContainer>
  )
}

export default OffersCustomToolbar
